import { privateApi } from '@/modules/shared/api/api.private';

export async function createWishlistItem({ name, url, description }) {
  const { data } = await privateApi({
    method: 'POST',
    url: '/wishlist',
    data: { name, url, description },
  });
  return { item: data };
}

export async function fetchMyWishlist() {
  const { data } = await privateApi({
    method: 'GET',
    url: '/wishlist',
  });
  return { items: data };
}

export async function fetchUserWishlist({ userId }) {
  const { data } = await privateApi({
    method: 'GET',
    url: `/wishlist/user/${userId}`,
  });
  return { items: data.items, user: data.user };
}

export async function updateWishlistItem({ id, name, url, description }) {
  const { data } = await privateApi({
    method: 'PUT',
    url: `/wishlist/${id}`,
    data: { name, url, description },
  });
  return { item: data };
}

export async function deleteWishlistItem({ id }) {
  await privateApi({
    method: 'DELETE',
    url: `/wishlist/${id}`,
  });
}

export async function reserveWishlistItem({ id }) {
  const { data } = await privateApi({
    method: 'POST',
    url: `/wishlist/${id}/reserve`,
  });
  return { item: data };
}

export async function unreserveWishlistItem({ id }) {
  const { data } = await privateApi({
    method: 'POST',
    url: `/wishlist/${id}/unreserve`,
  });
  return { item: data };
}
